export default "__VITE_ASSET__b29ce4d8__"